import FeedbackSection from 'components/Pages/Main/Feedback/Feedback';

/**
 * Сторінка /feedback — ADR-0006.
 *
 * Раніше форма існувала в двох майже однакових копіях: у секції головної та на
 * цій сторінці, з розбіжностями в обробці відправки. Тепер це один компонент;
 * standalone перемикає заголовок секції на заголовок сторінки.
 */
export default function Feedback() {
  return <FeedbackSection standalone />;
}
